const IS_LOADING = "lists/content_types/IS_LOADING";
const IS_ERROR = "lists/content_types/IS_ERROR";
const DATA = "lists/content_types/DATA";
const CONTENT_TYPE_EDIT = "lists/content_types/CONTENT_TYPE_EDIT";

export { IS_LOADING, IS_ERROR, DATA, CONTENT_TYPE_EDIT };
